export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null
  }

  return document.cookie.split(';').reduce((acc, item: string) => {
    const [key, value] = item.split('=').map((v) => v.trim())

    acc[key] = value

    return acc
  }, {} as { [key: string]: string })[name]
}

export function setCookie(name: string, value: string, days?: number) {
  if (typeof document === 'undefined') {
    return null
  }

  const date = new Date()
  const ONE_DAY = 24 * 60 * 60 * 1000
  date.setTime(date.getTime() + days * ONE_DAY)

  const expires =
    days == null
      ? 'expires=Fri, 31 Dec 9999 23:59:59 GMT'
      : `expires=${date.toUTCString()}`

  document.cookie = `${name}=${value}; ${expires}; path=/`
}
